import { Outlet, useLocation, useNavigate } from "react-router-dom";

import Diversity3Icon from "@mui/icons-material/Diversity3";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";

const SettingLayout = () => {
  const { pathname } = useLocation();

  const navigator = useNavigate();

  const menus = [
    // {
    //   path: "/alert",
    //   name: "Alert",
    //   icon: <NotificationsIcon fontSize="small" />,
    // },
    {
      path: "/setting/plan",
      name: "General",
      icon: <HomeRepairServiceIcon fontSize="small" />,
    },
    {
      path: "/setting/referral",
      name: "Referral",
      icon: <Diversity3Icon fontSize="small" />,
    },
    {
      path: "/setting/email",
      name: "Email Preferences",
      icon: <MailOutlineIcon fontSize="small" />,
    },
    {
      path: "/setting/preferred-programs",
      name: "Program Preference",
      icon: <FavoriteIcon fontSize="small" />,
    },
  ];
  return (
    <div className="max-w-7xl mx-auto md:mt-[20px] md:flex">
      <div className="md:w-[210px] md:mr-[15px]">
        <MenuList
          className="flex md:block overflow-x-auto overflow-y-hidden no-scrollbar"
          sx={{
            ".MuiMenuItem-root": {
              minHeight: "auto",
              borderRadius: "6px",
            },
          }}
        >
          {menus.map((item) => (
            <MenuItem
              selected={pathname === item.path}
              key={item.name}
              onClick={() => navigator(item.path)}
              className="!mb-[4px]"
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText>
                <Typography color="textPrimary">{item.name}</Typography>
              </ListItemText>
            </MenuItem>
          ))}
        </MenuList>
      </div>
      <Paper className="bg-[#fff] p-[20px] min-h-[60vh] flex-1">
        <Outlet />
      </Paper>
    </div>
  );
};

export default SettingLayout;
